<svg fill="none" height="10" viewBox="0 0 11 10" width="11" xmlns="http://www.w3.org/2000/svg">
	<path d="M10.7751 0.5H9.4522C9.1645 0.5 8.8909 0.638688 8.72166 0.876439L4.28767 7.04665L2.2794 4.25024C2.11017 4.01532
    1.83939 3.87381 1.54887 3.87381H0.226006C0.0426663 3.87381 -0.0645166 4.08325 0.0426663 4.23326L3.55714 9.12415C3.64016 9.24043
    3.74961 9.33518 3.87641 9.40054C4.00321 9.4659 4.14371 9.5 4.28626 9.5C4.42882 9.5 4.56932 9.4659 4.69612 9.40054C4.82292 9.33518
    4.93237 9.24043 5.01539 9.12415L10.9556 0.859458C11.0656 0.709448 10.9584 0.5 10.7751 0.5Z" fill="#36AF47" />
</svg>
